package floris.graphics.backoffice.pages.admin.techstacks.manage

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import floris.graphics.backoffice.components.ImageChooser
import floris.graphics.backoffice.components.layouts.PageLayout
import floris.graphics.backoffice.components.sections.DetailsSection
import floris.graphics.core.constants.Res
import com.materialdesignsystem.components.widgets.DangerFilledButton
import com.materialdesignsystem.components.widgets.DsBorderRadius
import com.materialdesignsystem.components.widgets.DsEditableField
import com.materialdesignsystem.components.widgets.DsReadOnlyField
import com.materialdesignsystem.components.widgets.FilledButton
import com.materialdesignsystem.components.widgets.TextButton
import com.materialdesignsystem.toColorScheme
import kotlinx.browser.window
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

@Page("/admin/techstacks/manage")
@Composable
fun ManageTechstackPage() {

    val context = rememberPageContext()
    val techstackId = remember(context.route) {
        context.route.params["id"]
    }

    val viewModel = remember(techstackId) { ManageTechstackViewModel(techstackId) }
    val state by viewModel.state.collectAsState()

    LaunchedEffect(Unit) {
        viewModel.eventFlow.collect {
            when (it) {
                ManageTechstackUiEvent.NavigateBack -> {
                    // TODO [TicketNumber]: Route is still in the history stack, so we need to remove it...
                    window.history.back()
                }

                ManageTechstackUiEvent.ShowError -> window.alert("An error occurred while processing your request.")
            }
        }
    }

    ManageTechstackPageContent(
        state = state,
        onEvent = viewModel::onEvent
    )
}

@Composable
private fun ManageTechstackPageContent(
    state: ManageTechstackState,
    onEvent: (ManageTechstackEvent) -> Unit
) {
    val breakpoint = rememberBreakpoint()

    PageLayout(if (state.isCreationFlow) "Techstack aanmaken" else "Techstack bewerken") {
        Column(
            modifier = Modifier
                .fillMaxWidth(if (breakpoint > Breakpoint.LG) 60.percent else 90.percent)
                .fillMaxHeight()
                .maxWidth(800.px)
                .padding(topBottom = 58.px),
            verticalArrangement = Arrangement.spacedBy(24.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            ImageChooser(
                modifier = Modifier
                    .size(200.px)
                    .background(ColorMode.current.toColorScheme.secondaryContainer),
                id = "logo_chooser",
                label = "Techstack Logo",
                imageUrl = state.logoUrl ?: state.originalTechstack.logoMediaFile?.url?.toString(),
                centerText = "Klik hier om een logo te kiezen",
                isLoading = state.uploadingLogo,
                onFileSelected = { onEvent(ManageTechstackEvent.UpdateLogo(it)) }
            )

            DsEditableField(
                modifier = Modifier.fillMaxWidth(),
                id = "name",
                label = Res.String.Name,
                placeholder = Res.String.EnterName,
                value = state.name,
                onValueChange = { onEvent(ManageTechstackEvent.UpdateName(it)) }
            )

            if (state.originalTechstack.id.isNotBlank()) {
                DetailsSection(
                    modifier = Modifier.fillMaxWidth(),
                    title = Res.String.Metadata
                ) {
                    Column(Modifier.fillMaxWidth(), Arrangement.spacedBy(16.px)) {
                        DsReadOnlyField(
                            modifier = Modifier.fillMaxWidth(),
                            label = Res.String.ID,
                            value = state.originalTechstack.id
                        )

                        DsReadOnlyField(
                            modifier = Modifier.fillMaxWidth(),
                            label = Res.String.CreatedAt,
                            value = state.originalTechstack.createdAt
                        )

                        DsReadOnlyField(
                            modifier = Modifier.fillMaxWidth(),
                            label = Res.String.UpdatedAt,
                            value = state.originalTechstack.updatedAt
                        )

                        DangerFilledButton(
                            onClick = { onEvent(ManageTechstackEvent.Delete) }
                        ) {
                            Text(Res.String.Delete)
                        }
                    }
                }
            }

            Row(horizontalArrangement = Arrangement.spacedBy(16.px)) {
                FilledButton(
                    enabled = state.hasChanged,
                    onClick = { onEvent(ManageTechstackEvent.Save) }
                ) {
                    Text(Res.String.Save)
                }

                TextButton(
                    onClick = { onEvent(ManageTechstackEvent.Cancel) }
                ) {
                    Text(Res.String.Cancel)
                }
            }
        }
    }
}


